export default "/3.png"